module.exports = __webpack_public_path__ + "img/blend3icon2.b1252f19.png";